import DomainProvider from './DomainProvider'

export {
    useCurrentDomainContext,
    useJHireURL,
    useAdminURL,
} from './domainHooks'

export type {
    DomainProviderContextValue,
} from './DomainProvider'

export default DomainProvider
